import { useState } from 'react'

import { useTranslation } from 'react-i18next'

import { QRCodeCanvas } from 'qrcode.react'

import { Box as DarkBox, DownloadIcon } from '@hivewatch/dark'

import { downloadQRasPNG } from '@/utils/downloadQRasPNG'

import { darkCheckPointsPanelStyles } from './DarkCheckPointsPanel.styles'

interface DarkCheckPointQRCodeIProps {
  colorScheme: 'dark' | 'light'
  id: string
  displayId: string
  name: string
}

/**
 * Dark twin of CheckPointQRCode. The canvas keeps its fixed black-on-white
 * rendering so the code stays scannable; the frame, the ID and the download
 * label take their colours from the theme, which the legacy hexes did not.
 */
export const DarkCheckPointQRCode = ({
  colorScheme,
  id,
  displayId,
  name,
}: DarkCheckPointQRCodeIProps) => {
  const { t } = useTranslation()
  const [shouldShowDownload, setShowDownload] = useState(false)
  const s = darkCheckPointsPanelStyles(colorScheme)

  return (
    <DarkBox
      {...s.qrFrame}
      data-testid='checkpointPanel_editCheckpoint_QrCodeContainer'
      onClick={() => downloadQRasPNG(name, displayId, 'qrCode')}
      onMouseEnter={() => setShowDownload(true)}
      onMouseLeave={() => setShowDownload(false)}
    >
      <DarkBox {...s.qrCanvasWrap}>
        <QRCodeCanvas
          id='qrCode'
          level='H'
          size={720}
          style={{ width: 104, height: 104 }}
          value={id}
        />
        {shouldShowDownload && (
          <DarkBox
            {...s.qrDownloadOverlay}
            data-testid='checkpointPanel_editCheckpoint_QrCodeDownloadButton'
          >
            <DownloadIcon color='white' size={28} />
          </DarkBox>
        )}
      </DarkBox>
      <DarkBox {...s.qrMeta}>
        <DarkBox {...s.qrDownloadLabel}>
          {t('floors:checkpoint_qr_download')}
        </DarkBox>
        <DarkBox {...s.qrDisplayId}>{displayId}</DarkBox>
      </DarkBox>
    </DarkBox>
  )
}
